/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgNote56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        d='M19.25 30.5h28V29h-28v1.5zM47.25 37.5h-28V36h28v1.5zM19.25 44.5h10.5V43h-10.5v1.5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.536 8a7.751 7.751 0 0115.428 0h7.322a7.75 7.75 0 0115.428 0h2.536A2.75 2.75 0 0155 10.75v41.5A2.75 2.75 0 0152.25 55H3.75A2.75 2.75 0 011 52.25v-41.5A2.75 2.75 0 013.75 8h7.786zm1.508 0a6.251 6.251 0 0112.412 0H13.043zM42 2.5A6.251 6.251 0 0148.206 8H35.794A6.251 6.251 0 0142 2.5zm-15.036 7h21.242A6.251 6.251 0 0142 15a.75.75 0 000 1.5 7.751 7.751 0 007.714-7h2.536c.69 0 1.25.56 1.25 1.25v9.5H13v-9.5c0-.69.56-1.25 1.25-1.25h11.206A6.251 6.251 0 0119.25 15a.75.75 0 000 1.5 7.75 7.75 0 007.714-7zM6.55 9.5h-2.8c-.69 0-1.25.56-1.25 1.25v41.5c0 .69.56 1.25 1.25 1.25h2.8c-.192-.375-.3-.8-.3-1.25v-41.5c0-.45.108-.875.3-1.25zM9 53.5h2.8c-.192-.375-.3-.8-.3-1.25v-41.5c0-.45.108-.875.3-1.25H9c-.69 0-1.25.56-1.25 1.25v41.5c0 .69.56 1.25 1.25 1.25zm5.25 0c-.69 0-1.25-.56-1.25-1.25v-30.5h40.5v30.5c0 .69-.56 1.25-1.25 1.25h-38z'
      />
    </svg>
  );
}

export default SvgNote56;
